import { Component } from '@angular/core';
import { MerchantService } from '../../../models/merchant/merchantService';
import { Merchant } from '../../../models/merchant/merchant';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { StorageService } from '../../../core/storage/storageService';
import { Router } from '@angular/router';
import { AccountService } from '../../../models/account/accountService';
import { UIHelpers } from '../../../core/ui-helpers';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { Options } from '../../ui/filterable-table/options';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-merchant-table-view',
  templateUrl: './merchant-table-view.component.html',
  standalone: false,
})
export class MerchantTableViewComponent extends TableViewAbstractComponent {
  //public selectedRoute: string = "";

  //public selectedRoute: string = "";

  canViewAccounts: boolean = false;
  canSelectFavorites: boolean = false;
  loading = true;
  IconType = IconType;

  constructor(
    public merchantService: MerchantService,
    private storage: StorageService,
    private router: Router,
    private accountService: AccountService,
    private uiHelpers: UIHelpers,
    private uiErrorHandler: UIErrorHandler,
    private access: AccessManager,
  ) {
    super();

    this.access
      .getUserAccess([
        AccessManager.AUTH_SELECT_ALL_MERCHANTS,
        AccessManager.AUTH_DASHBOARD_FAVORITES,
      ])
      .then((access) => {
        this.canViewAccounts =
          access[AccessManager.AUTH_SELECT_MERCHANT_ACCOUNT];
        this.canSelectFavorites =
          access[AccessManager.AUTH_DASHBOARD_FAVORITES];
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  getRecordFromDataSource(merchantId: string): Merchant {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == merchantId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Merchant not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: any[],
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
    options: Options,
  ): Promise<Page<Merchant>> {
    let restrictToMyMerchants: boolean = false;

    if (
      options.restrictToMyMerchants != undefined &&
      options.restrictToMyMerchants == true
    ) {
      restrictToMyMerchants = true;
    }

    this.loading = true;
    return this.merchantService
      .getPaged(
        this.options.accountId ? this.options.accountId : '',
        query,
        pageNum,
        pageSize,
        sortColumn,
        sortDirection,
        restrictToMyMerchants,
        this.options.userId ? this.options.userId : '',
      )
      .then((results) => {
        this.loading = false;
        return results;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        return new Page<Merchant>({});
      }).finally(() => this.loading = false);
  }

  canQuery(): boolean {
    return true;
  }

  deleteMerchantUser(merchantId: string) {
    const message = `Are you sure you want to remove this business from this user?`;
    if (!confirm(message)) {
      return
    }
    this.merchantService
      .deleteMerchantContactInfo(merchantId, this.options.userId!)
      .then((response) => {
        this.dataSource.data = this.dataSource.data.filter(
          (item) => item.id != merchantId,
        );
        this.dataSource._updateChangeSubscription();
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  btnManageAccount_click(id: string) {
    this.merchantService
      .getMerchantById(id)
      .then((merch) => {
        this.accountService
          .getAccount(merch.accountId)
          .then((account) => {
            this.storage.setSelectedAccount(account);
            this.uiHelpers.selectMerchant(new Merchant(merch));
            this.router.navigateByUrl(this.options.selectRoute);

            this.selectedRecord.emit(merch);
          })
          .catch((message) => {
            this.uiErrorHandler.handleError(message);
          });
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  recordStarred(recordId: string) {
    let usr = this.storage.getCurrentUser();

    if (usr) {
      this.merchantService.addMyMerchant(recordId, usr.id);
    }
  }

  recordUnstarred(recordId: string) {
    let usr = this.storage.getCurrentUser();

    if (usr) {
      this.merchantService.removeMyMerchant(recordId, usr.id);
    }
  }

  filterByLetter_click(letter: string) {}
}
